import React from 'react';

interface VideoResultProps {
  url: string;
  title: string;
  description: string;
}

const VideoResult: React.FC<VideoResultProps> = ({ url, title, description }) => {
  // Function to check if URL is from YouTube and extract video ID
  const getYouTubeVideoId = (url: string): string | null => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const youtubeVideoId = getYouTubeVideoId(url);

  return (
    <div className="flex flex-col w-full">
      {youtubeVideoId ? (
        // YouTube Embed
        <div className="relative w-full pt-[56.25%]">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube.com/embed/${youtubeVideoId}`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        // Thumbnail for non-YouTube videos
        <>
        <div className="relative w-full pt-[56.25%] bg-gray-100">
          <img
            src={url}
            alt={title}
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
        </div>
        <div className="mt-3">
        <h3 className="text-lg font-semibold text-[var(--rhea-text-primary)]">{title}</h3>
        <p className="mt-1 text-sm text-[var(--rhea-text-secondary)]">{description}</p>
      </div>
      </>
      )}
    </div>
  );
};

export default VideoResult;
